/* eslint-disable */
import { Controller } from 'stimulus';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';
import MediaMatcher from 'lib/media-matcher'
import frameDebounce from 'lib/frame-debounce'

const mediaMatcher = new MediaMatcher();

export default class SiteHeaderController extends Controller {
  static targets = [
    'menuGroup',
    'menuGroupStatic',
    'subMenu',
    'mobileMenu',
    'mainUserMenu',
  ];

  prependIds = [
    'menu-group-auth',
  ];

  isScrolled = false;

  connect() {
    if (this.hasMobileMenuTarget) {
      this.setupMenuGroupParents();

      this.setupSiteNavigationMediaQueries();

      mediaMatcher.evaluateAll();
      mediaMatcher.addListeners();
    }

    window.addEventListener('scroll', this.debouncedScrollCheck);
  }

  disconnect() {
    mediaMatcher.removeListeners();
    mediaMatcher.clearQueries();

    window.removeEventListener('scroll', this.debouncedScrollCheck);
  }

  checkScroll = () => {
    if (window.scrollY > 0 && this.isScrolled === false) {
      document.body.classList.add('is-scrolled');
      this.isScrolled = true;
    }
    else if (window.scrollY <= 0 && this.isScrolled === true) {
      document.body.classList.remove('is-scrolled');
      this.isScrolled = false;
    }
  }

  debouncedScrollCheck = frameDebounce(this.checkScroll);

  createOverlay(action) {
    const overlay = document.createElement('DIV');

    overlay.classList.add('ez-dark-overlay');
    overlay.classList.add('mobile-search-overlay');
    overlay.dataset.action = action;

    this.element.appendChild(overlay);
  }

  clearSearchInput() {
    this.element.querySelector('#search').value = '';
  }

  toggleMobileSearch() {
    const searchInput = document.getElementById('search');
    const bodyEl = document.querySelector('body');
    const overlayEl = document.querySelector('.ez-dark-overlay.mobile-search-overlay');

    bodyEl.classList.toggle('is-mobile-search');

    if (bodyEl.classList.contains('is-mobile-search') && !overlayEl) {
      this.createOverlay('click->site-header#toggleMobileSearch');

      searchInput.focus();

      searchInput.value = searchInput.value;
    } else if (!bodyEl.classList.contains('is-mobile-search') && overlayEl) {
      overlayEl.remove();
    }
  }

  setupSiteNavigationMediaQueries() {
    const bodyClass = document.querySelector('body').classList;

    if (bodyClass.contains('is-logged-in') && bodyClass.contains('is-pro')) {
      this.setupProUserMediaQueries();
    } else if (bodyClass.contains('is-logged-in')) {
      this.setupLoggedInMediaQueries();
    } else {
      this.setupLoggedOutMediaQueries();
    }
  }

  setupProUserMediaQueries() {
    mediaMatcher.addMediaQuery('(max-width: 940px)',
      () => { this.collectAllMenuGroups(); },
      () => { if (this.mobileMenuItems()) this.restoreAllMenuGroups(); }
    );
  }

  setupLoggedInMediaQueries() {
    mediaMatcher.addMediaQuery('(min-width: 1181px)',
      () => { this.restoreAllMenuGroups(); }
    );

    mediaMatcher.addMediaQuery('(max-width: 1180px) and (min-width: 941px)',
      () => {
        this.restoreAllMenuGroups();
        this.collectJoinBtn();
      }
    );

    mediaMatcher.addMediaQuery('(max-width: 940px)',
      () => {
        this.collectAllMenuGroups();
        this.collectJoinBtn();
      }
    );
  }

  setupLoggedOutMediaQueries() {
    mediaMatcher.addMediaQuery('(max-width: 1105px)',
      () => {
        this.collectAllMenuGroups();
        this.collectJoinBtn('menu-group-browse');
      },
      () => {
        if (this.mobileMenuItems()) this.restoreAllMenuGroups();
        this.collectJoinBtn('menu-group-auth');
      }
    );
  }

  setupMenuGroupParents() {
    this.menuGroupTargets.forEach((menuGroup) => {
      const parentMenu = menuGroup.closest('.ez-site-header__submenu-wrapper');

      if (!menuGroup.dataset.parentMenu) menuGroup.dataset.parentMenu = parentMenu.id;
    })
  }

  moveStaticMenuGroups(destination) {
    this.menuGroupStaticTargets.forEach((menuGroup) => {
      destination.appendChild(menuGroup);
    });
  }

  collectJoinBtn(altDest) {
    if (!document.querySelector('#menu-group-join-pro')) return;

    const destinationId = altDest || 'menu-group-user';

    const destination = document.querySelector(`#${destinationId}`);

    destination.insertBefore(
      document.querySelector('#menu-group-join-pro'),
      destination.childNodes[0]
    );
  }

  collectMenuGroup(menuGroup, destination) {
    if (!menuGroup) return false;
    
    const parentMenu = menuGroup.closest('.ez-site-header__submenu-wrapper');

    parentMenu.classList.add('is-hidden');

    this.prependIds.includes(menuGroup.id)
      ? destination.insertBefore(menuGroup, destination.childNodes[0])
      : destination.appendChild(menuGroup);
  }

  collectAllMenuGroups() {
    this.moveStaticMenuGroups(this.mobileMenuTarget);

    this.menuGroupTargets.forEach((menuGroup) => {
      if (!this.isStaticMenuGroup(menuGroup) && !this.isJoinButtonGroup(menuGroup)) {
        this.collectMenuGroup(menuGroup, this.mobileMenuTarget);
      }
    })
  }

  restoreMenuGroup(menuGroup, destination) {
    const parentMenu = destination.closest('.ez-site-header__submenu-wrapper');

    parentMenu.classList.remove('is-hidden');

    this.prependIds.includes(menuGroup.id)
      ? destination.insertBefore(menuGroup, destination.childNodes[0])
      : destination.appendChild(menuGroup);
  }

  restoreAllMenuGroups() {
    if (this.hasMainUserMenuTarget) this.moveStaticMenuGroups(this.mainUserMenuTarget);

    this.menuGroupTargets.forEach((menuGroup) => {
      if (!this.isStaticMenuGroup(menuGroup)) {
        const parentMenu = document.querySelector(`#${menuGroup.dataset.parentMenu}`);
        const parentSubMenu = parentMenu.querySelector('.ez-drop-down__submenu');

        const destination = parentSubMenu ? parentSubMenu : parentMenu;

        this.restoreMenuGroup(menuGroup, destination);
      }
    });
  }

  isJoinButtonGroup(menuGroup) {
    return menuGroup.id === 'menu-group-join-pro';
  }

  isStaticMenuGroup(menuGroup) {
    return menuGroup.getAttribute('data-target').indexOf('menuGroupStatic') > -1;
  }

  mobileMenuItems() {
    const dropdowns = this.mobileMenuTarget.querySelector('#mobile-menu .ez-drop-down__submenu-group')
    const groups = this.mobileMenuTarget.querySelector('#mobile-menu .ez-site-header__submenu-group')
    return dropdowns || groups;
  }

  headerLogin() {
    triggerCustomEvent(events.site_header.header_login);
  }

  headerSignUp() {
    triggerCustomEvent(events.site_header.header_signup);
  }

  sendHeaderJoinProEvent() {
    triggerCustomEvent(events.site_header.header_join_pro);
  }

  sendExploreNavEvent() {
    triggerCustomEvent(events.site_header.explore_nav);
  }
  
  // Start feature: photos
  sendExploreNewestEvent() {
    triggerCustomEvent(events.site_header.explore_newest);
  }

  sendExploreCatsEvent() {
    triggerCustomEvent(events.site_header.explore_cats);
  }

  sendExploreBrusheezyEvent() {
    triggerCustomEvent(events.site_header.explore_brusheezy);
  }

  sendExploreVideezyEvent() {
    triggerCustomEvent(events.site_header.explore_videezy);
  }
  // End feature: photos
}
